export default () =>
  import(/* webpackChunkName: 'coffee/test/app-api' */ './AppApi');
